import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myRight: [],
  allMyRight: []
};

export const MyRightsSlice = createSlice({
  name: "myRights",
  initialState,
  reducers: {
    getMyRightsAction: (state, action) => {
      
      state.allMyRight = action.payload;
    },
    getMyRightAction: (state, action) => {
      state.myRight = action.payload;
    },
  },
});

export default MyRightsSlice.reducer;

export const { getMyRightsAction, getMyRightAction } = MyRightsSlice.actions;
